import { render } from "./ProgramListingTable.vue?vue&type=template&id=8b6b33fe"
import script from "./ProgramListingTable.vue?vue&type=script&lang=js"
export * from "./ProgramListingTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__